import React from "react";

const Button = ({ text, onClick, gradient, textColor,border, padding }) => {
  const buttonStyle = {
    background: gradient,
    color: textColor,
    fontWeight: "bold",
   
    cursor: "pointer",
   
    border: border,
    padding : padding

  };

  return (
    <button
      className={`font-bold py-2 px-4 rounded shadow ${textColor} ${border} ${padding} min-w-20 rounded-3xl`}
      style={buttonStyle}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default Button;

